<template>
  <button
    v-ripple
    :class="['custom-button', className, classByType]"
    :disabled="disabled"
    type="button"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "RippleButton",
  directives: {
    ripple: {},
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    classByType() {
      switch (this.type) {
        case "prime":
          return "primery";
        case "second":
          return "secondary";
        case "simple":
          return "simple";

        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$background-button-white: #fff;
$text-button-simple: #151515;

.custom-button {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 100%;
  border-radius: 100px;
  font-size: 18px;
  line-height: 21.6px;
  font-weight: 700;
  padding: 18px 45px 18px 45px;
  margin: 5px 0;
}

.custom-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.short {
  width: unset;
}

.simple {
  color: $text-button-simple;
  background: $background-button-white;
  border: 1px solid $text-button-simple;
}

.primery {
  color: #ffffff;
  background-color: var(--success-color);
}

.secondary {
  color: #ffffff;
  background-color: var(--warning-color);
}
</style>
